<mat-toolbar color="primary" class="toolbar">
    <span class="logo-wrapper" [routerLink]="['/', 'about']">
        <mat-icon>home</mat-icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 72 40">
            <path fill-rule="evenodd"
                d="M6.32 4.68a1.74 1.74 0 0 1 1.16-.4 3.56 3.56 0 0 1 1.46.24c.47.193.92.434 1.34.72l1-3.08a7.24 7.24 0 0 0-2-.88A8.18 8.18 0 0 0 7.18 1a5.46 5.46 0 0 0-2.6.74 5.78 5.78 0 0 0-2 1.84 8.76 8.76 0 0 0-1.24 2.8 14.3 14.3 0 0 0-.42 3.58 14 14 0 0 0 .72 4.78 6.14 6.14 0 0 0 2 2.96 5.56 5.56 0 0 0 3.38 1.02 8.74 8.74 0 0 0 2-.22 6.26 6.26 0 0 0 1.7-.66v-3.4c-.48.287-.98.534-1.5.74a4.58 4.58 0 0 1-1.56.28 2.12 2.12 0 0 1-1.56-.62A3.58 3.58 0 0 1 5.14 13a11.64 11.64 0 0 1-.34-3.08c-.006-.77.054-1.54.18-2.3a6.18 6.18 0 0 1 .5-1.8 3.14 3.14 0 0 1 .84-1.14ZM20.9 1.86a8 8 0 0 0-3.26-.56H13.3v17.12h3.78v-6.54h.68l2.76 6.54h4.2l-3.56-7.48a5.64 5.64 0 0 0 1.34-1.22 5.32 5.32 0 0 0 .78-1.54 6.1 6.1 0 0 0 .26-1.88 5.6 5.6 0 0 0-.64-2.78 4 4 0 0 0-2-1.66Zm-3.8 2.58h.52a2 2 0 0 1 1.52.58c.353.432.525.984.48 1.54a2.94 2.94 0 0 1-.48 1.84 1.86 1.86 0 0 1-1.5.6h-.54V4.44Zm17 13.98H26V1.3h8v3.2h-4.16v3.46h4v3.2h-4v4h4.26v3.26Zm16.76 0 3.3-17.12-3.76.04-1.38 8c-.1.5-.2 1.06-.28 1.62a17.62 17.62 0 0 1-.085.512c-.068.388-.135.773-.135 1.148-.073.497-.12.998-.14 1.5-.116-.288-.127-.565-.14-.863a13.16 13.16 0 0 0-.18-1.637c-.08-.42-.16-.84-.22-1.22a5.292 5.292 0 0 0-.098-.449c-.053-.212-.102-.412-.102-.591l-1.48-8H43.1l-1.62 8c-.026.17-.061.374-.099.595a107.645 107.645 0 0 0-.112.675c-.044.274-.092.567-.15.87-.03.159-.043.32-.056.484-.022.269-.044.542-.143.816-.16.44-.16.88-.16 1.3-.088-.251-.097-.495-.107-.75a4.592 4.592 0 0 0-.033-.47c-.018-.13-.04-.258-.06-.386-.05-.304-.1-.604-.1-.914l-.18-1.24c-.16-.38-.16-.74-.16-1.04l-1.36-8H35.1l3.32 17.12h4.28l1.34-7.12c.031-.135.047-.273.064-.416.025-.216.051-.443.136-.684.07-.2.07-.395.07-.59 0-.195 0-.39.07-.59.076-.218.08-.435.086-.647.004-.177.008-.349.054-.513.1-.36.1-.7.1-1.02l.12 1.18c.087.25.096.491.106.73.006.144.011.287.034.43.018.116.04.23.062.343.05.257.098.507.098.757l.18 1.04 1.34 7.1h4.3ZM32.78 38.66h-3.72v-13.9H2.38v-3.24h33.5v3.24h-3.1v13.9ZM38 21.52v17.14h3.8V21.52H38Zm5.48 17.14 3.3-17.14h4.32l1.32 7.12c0 .32.06.66.18 1.02 0 .218.044.442.088.666.028.146.057.291.072.434.013.112.018.23.022.352.011.266.022.547.119.808l.12 1.18c0-.3 0-.64.1-1.02.045-.173.05-.346.053-.52.005-.21.01-.422.087-.64.067-.193.07-.382.072-.57.002-.202.005-.403.087-.61.034-.372.101-.74.2-1.1l1.32-7.12h4.28l3.32 17.14h-3.66l-1.36-8c0-.3 0-.64-.16-1.04l-.18-1.24a5.48 5.48 0 0 0-.103-.928c-.02-.118-.04-.235-.056-.352a4.428 4.428 0 0 1-.034-.468c-.01-.26-.019-.514-.107-.752 0 .4 0 .84-.16 1.28-.099.274-.121.547-.143.816a4.545 4.545 0 0 1-.056.484 14.46 14.46 0 0 0-.094.57c-.032.216-.064.426-.106.63a13.041 13.041 0 0 0-.16.94l-1.62 8h-3.06l-1.48-8c0-.179-.05-.379-.103-.591a5.56 5.56 0 0 1-.098-.449c-.023-.15-.05-.307-.078-.468a27.102 27.102 0 0 1-.122-.752c-.02-.14-.042-.28-.064-.42-.044-.28-.089-.56-.116-.84-.04-.42-.1-.84-.16-1.22-.02.502-.067 1.003-.14 1.5 0 .365-.064.73-.13 1.108-.032.18-.064.364-.09.552-.08.58-.18 1.1-.28 1.62l-1.38 8-3.76.02Zm19.92 0h8v-3.28h-4.26v-4h4v-3.2h-4v-3.46h4.26v-3.2h-8v17.14Z"
                clip-rule="evenodd"></path>
        </svg>
    </span>
    <!-- <span class="title desktop-only">{{ pageTitle$ | async }}</span> -->
    <div class="toolbar-spacer"></div>
    <span class="menu-wrapper">
        <span class="environment" *ngIf="environment=='dev'">
            {{ environment }}
        </span>
        <span class="impersonated" *ngIf="impersonate" [routerLink]="['/',  'dev', 'tools']">
            [{{ impersonate }}]
            <button mat-icon-button (click)="removeImpersonate()"><mat-icon>delete</mat-icon></button>
        </span>
        <span [matMenuTriggerFor]="profileMenu" class="profile-menu-opener" #profileMenuTrigger="matMenuTrigger">
            <span class="user-menu-username">
                {{ (user$ | async)?.usname }}
            </span>
            <img [src]="profilePic" class="profile-pic" *ngIf="!!profilePic; else noPic">
            <ng-template #noPic>
                <mat-icon>account_circle</mat-icon>
            </ng-template>
        </span>
        <mat-menu #profileMenu="matMenu" yPosition="below" xPosition="before" class="menu">
            <div class="menu-closer">
                <mat-icon (click)="closeMenu(profileMenuTrigger)">close</mat-icon>
            </div>
            <div class="menu-items with-separator">
                <a mat-menu-item [routerLink]="['/', 'my', 'm30']">M30 letöltés</a>
                <a mat-menu-item [routerLink]="['/', 'report', 'm30']">M30 Admin</a>
            </div>
            <!-- {{ selectedPosition }} -->
            <!-- <div class="menu-items with-separator darker">
                <hr>
                <div class="title">Szerződésed:</div>
                <ul class="positions">
                    <li *ngFor="let pos of positions$ | async" class="position" 
                        [class.selected]="isSelectedPosition(pos)"
                        (click)="selectPosition(pos)">
                        <div class="selector">
                        <mat-icon *ngIf="isSelectedPosition(pos); else notSelectedPos">check_circle_outline</mat-icon>
                        <ng-template #notSelectedPos>
                            <mat-icon>radio_button_unchecked</mat-icon>
                        </ng-template>  
                        </div>
                        <div class="selectable-value">
                            {{ pos.role }}
                        </div>
                    </li>
                </ul>
                <div class="no-contract" *ngIf="!(positions$ | async)?.length">
                    You have no contract.
                    <a [routerLink]="['/', 'my', 'contracts']">Create one now!</a>
                </div>
            </div>
            <div class="menu-items with-separator">
                <hr>
                <div class="title">Jogosultságod:</div>
                <div *ngFor="let role of roles" class="role">
                    {{ role }}
                </div>
            </div> -->
            <div class="menu-items with-separator">
                <button mat-menu-item color="secondary" (click)="logout()" *ngIf="(user$ | async)">
                    Kijelentkezés
                </button>
            </div>
        </mat-menu>
    </span>
    <span class="menu-wrapper" *ngIf="isMoreThanDeptHead">
        <span [matMenuTriggerFor]="mainMenu" class="main-menu-opener" #mainMenuTrigger="matMenuTrigger">
            <mat-icon>menu</mat-icon>
        </span>
        <mat-menu #mainMenu="matMenu" yPosition="below" xPosition="before" class="menu">
            <div class="menu-closer">
                <mat-icon (click)="closeMenu(mainMenuTrigger)">close</mat-icon>
            </div>

            <div class="menu-items with-separator">
                <hr>
                <a mat-menu-item [routerLink]="['/',  'admin','users']" *ngIf="isProdMgr || isDev">Users</a>
                <a mat-menu-item [routerLink]="['/',  'contract', 'list']" *ngIf="isProdMgr || isFinance || isDev">SF / Contracts</a>
                <a mat-menu-item [routerLink]="['/',  'ts', 'list']">Timesheets</a>
                <a mat-menu-item [routerLink]="['/',  'ts', 'generate-invrep']" *ngIf="isFinance || isDev">WTS generation</a>
                <a mat-menu-item [routerLink]="['/',  'admin', 'prod-defaults']" *ngIf="isProdMgr || isDev">Production</a>
                <a mat-menu-item [routerLink]="['/',  'admin', 'dept-defaults']" *ngIf="isProdMgr || isDev">Departments</a>
                <a mat-menu-item [routerLink]="['/',  'admin', 'contract-fields']" *ngIf="isDev">Custom fields</a>
            </div>

            <div class="menu-items with-separator" *ngIf="isDev">
                <hr>
                <button mat-menu-item color="secondary" (click)="debug = !debug">
                    DEBUG mód {{ debug ? 'ki' : 'be' }}
                </button>
                <a mat-menu-item [routerLink]="['/',  'dev', 'tools']" *ngIf="isDev">Dev Eszközök</a>
                <a mat-menu-item [routerLink]="['/',  'dev', 'minden']">Gábornak</a>
            </div>

        </mat-menu>

    </span>
</mat-toolbar>